export const INIT_customer_portal = () => {
  const customerSelectForm = document.getElementById(
    'form_admin_select_customer'
  );

  if (customerSelectForm) {
    const customerDropdown = customerSelectForm.querySelector('select');

    if (typeof customerDropdown != 'undefined' && customerDropdown != null) {
      customerDropdown.addEventListener('change', () => {
        customerSelectForm.submit();
      });
    }
  }
};
